import React from 'react'
import { consts } from 'react-elastic-carousel'
import { FaAngleRight, FaAngleLeft } from 'react-icons/fa'
import PropTypes from 'prop-types'

export const myArrow = ({ type, onClick, isedge }) => {
  const className =
    type === consts.PREV
      ? 'home-section__slider-arr-left'
      : 'home-section__slider-arr-right'

  const pointer =
    type === consts.PREV
      ? (
      <FaAngleLeft
        className={`${className} d-none d-md-block`}
        onClick={onClick}
        isedge={isedge}
      />
        )
      : (
      <FaAngleRight
        className={`${className} d-none d-md-block`}
        onClick={onClick}
        isedge={isedge}
      />
        )

  return <div className="d-flex align-items-center ">{pointer}</div>
}

export const MobileArrowButtons = (props) => {
  return (
    <>
      <FaAngleLeft
        className="home-section__slider-arr-left mr-2"
        onClick={() => props.carousel.current.slidePrev()}
      />
      <FaAngleRight
        className="home-section__slider-arr-right"
        onClick={() => props.carousel.current.slideNext()}
      />
    </>
  )
}

MobileArrowButtons.propTypes = {
  carousel: PropTypes.object
}
